import { render, staticRenderFns } from "./declaracaoArqFederal.vue?vue&type=template&id=63e6359a&scoped=true&"
import script from "./declaracaoArqFederal.vue?vue&type=script&lang=js&"
export * from "./declaracaoArqFederal.vue?vue&type=script&lang=js&"
import style0 from "./declaracaoArqFederal.vue?vue&type=style&index=0&id=63e6359a&lang=scss&scoped=true&"
import style1 from "./declaracaoArqFederal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e6359a",
  null
  
)

export default component.exports